import { Dialog, Grid } from '@material-ui/core';
import { PrimaryButton, SecondaryButton, Text } from 'library';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { track } from 'shared';

const JustBookedModal = ({
    visible,
    providerName,
    onClose,
    quickBook,
}: {
    quickBook?: boolean;
    visible: boolean;
    providerName: string;
    onClose: () => void;
}) => {
    const history = useHistory();
    const tracking = quickBook ? 'Quick Book:' : 'Instant Book:';

    return (
        <Dialog
            fullWidth
            disableEnforceFocus
            maxWidth="sm"
            open={visible}
            onClose={onClose}
            scroll="paper"
            PaperProps={{
                style: {
                    boxShadow: 'none',
                    borderRadius: 18,
                },
            }}
        >
            <Grid container xs={12} style={{ padding: '3%' }}>
                <Grid direction="row" justify="space-between" item container xs={12} style={{ marginBottom: 10 }}>
                    <Text variant="h1">Nice!</Text>
                    <Text variant="body1" onClick={onClose}>
                        x
                    </Text>
                </Grid>
                <Grid item xs={12}>
                    <Text variant="body1">
                        {quickBook
                            ? 'We have posted your job, to look over or edit the details go to upcoming jobs.'
                            : `We are confirming your request with ${providerName}. We will text you when your job is booked.`}
                    </Text>
                </Grid>
                <Grid item xs={12} style={{ marginTop: 20 }}>
                    <PrimaryButton
                        onClick={() => {
                            onClose();
                            track(`${tracking} Explore Providers`);
                            history.push('/providers');
                        }}
                    >
                        Explore Providers
                    </PrimaryButton>
                    <SecondaryButton
                        buttonStyle={{ marginTop: 20 }}
                        onClick={() => {
                            onClose();
                            track(`${tracking} View Upcoming`);
                            history.push('/jobs');
                        }}
                    >
                        View upcoming jobs
                    </SecondaryButton>
                </Grid>
            </Grid>
        </Dialog>
    );
};

export default JustBookedModal;
